/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Issue_TakenInputs */

const en_reference_issue_taken = /** @type {(inputs: Reference_Issue_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already used by another record`)
};

/**
* | output |
* | --- |
* | "Already used by another record" |
*
* @param {Reference_Issue_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_issue_taken = /** @type {((inputs?: Reference_Issue_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Issue_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_issue_taken(inputs)
});